import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeCategory: {},
  categoryChannels: {
    channels: [],
    currentPage: 0,
    size: 0,
    totalPages: 0,
    totalRecords: 0,
  },
};

const exploreChannelsSlice = createSlice({
  name: 'explorechannelcategory',
  initialState,
  reducers: {
    setActiveCategoryId(state, action) {
      state.activeCategory = action.payload;
    },
    clearActiveCategoryId(state) {
      state.activeCategory = null;
    },
    setCategoryChannels(state, action) {
      const payload = action.payload || {};
      if (payload.channels && Array.isArray(payload.channels)) {
        state.categoryChannels = {
          channels: payload.channels,
          currentPage: payload.currentPage ?? payload.page ?? 1,
          size: payload.size ?? 0,
          totalPages: payload.totalPages ?? payload.total_pages ?? 0,
          totalRecords: payload.totalRecords ?? payload.totalRecords ?? 0,
        };
      } else {
        if (Array.isArray(payload)) {
          state.categoryChannels = {
            channels: payload,
            currentPage: 1,
            size: payload.length,
            totalPages: 1,
            totalRecords: payload.length,
          };
        } else {
          state.categoryChannels = { channels: [], currentPage: 0, size: 0, totalPages: 0, totalRecords: 0 };
        }
      }
    },
    clearCategoryChannels(state) {
      state.categoryChannels = { channels: [], currentPage: 0, size: 0, totalPages: 0, totalRecords: 0 };
    },
  },
});

export const { setActiveCategoryId, clearActiveCategoryId, setCategoryChannels, clearCategoryChannels } = exploreChannelsSlice.actions;

export const getActiveCategoryId = (state) => state.explorechannelcategory?.activeCategory ?? null;
export const getCategoryChannels = (state) => state.explorechannelcategory?.categoryChannels ?? { channels: [], currentPage: 0, size: 0, totalPages: 0, totalRecords: 0 };

export default exploreChannelsSlice.reducer;